import React from 'react';
import cx from './cx';

function Badge({ children, variant = 'muted', size = 'sm', status = false, className, ...props }) {
  return (
    <span
      className={cx(
        'rg-badge',
        `rg-badge--${variant}`,
        size === 'md' && 'rg-badge--md',
        size === 'sm' && 'rg-badge--sm',
        status && 'rg-badge--status',
        className
      )}
      {...props}
    >
      {children}
    </span>
  );
}

export default Badge;
